import React from 'react';
import { FaTrash } from 'react-icons/fa';
import { RtModal } from '../../ui/RtModal';

const DeleteModal = ({
  setIsDeleteModalOpen,
  projectToDelete,
  handleDeleteProject,
  setProjectToDelete,
}) => {
  const close = () => setIsDeleteModalOpen(false);

  return (
    <RtModal
      open
      onClose={close}
      title="Delete Project"
      size="sm"
      variant="destructive"
      footer={
        <>
          <button type="button" className="rt-btn rt-btn--secondary" onClick={close}>
            Cancel
          </button>
          <button
            type="button"
            className="rt-btn rt-btn--danger"
            onClick={async () => {
              await handleDeleteProject(projectToDelete.id);
              setIsDeleteModalOpen(false);
              setProjectToDelete(null);
            }}
          >
            Delete
          </button>
        </>
      }
    >
      <div className="rt-modal-confirm">
        <div className="rt-modal-confirm__icon" aria-hidden>
          <FaTrash />
        </div>
        <p className="rt-modal-confirm__message">
          Are you sure you want to delete this project?
        </p>
        {projectToDelete?.name ? (
          <p className="rt-modal-confirm__entity">
            <strong>{projectToDelete.name}</strong>
          </p>
        ) : null}
        <p className="rt-modal__hint">This action cannot be undone.</p>
      </div>
    </RtModal>
  );
};

export default DeleteModal;
